import { get_cdn_url, use_store } from "../store";

// LangButton component
const LangButton = ({ flag, ln_code }: { flag: string; ln_code: string }) => {
  const { ln, set_ln } = use_store();
  const is_active = ln === ln_code;

  return (
    <div
      onClick={() => set_ln(ln_code, true)}
      className={`flex items-center gap-[6px] px-[8px] py-[6px] rounded-[4px] cursor-pointer transition-all ${
        is_active ? "bg-brand-2 text-white" : "hover:bg-lines/50"
      }`}
    >
      <span className="text-[16px]">{flag}</span>
      <span className="text-[12px]">
        {ln_code === "en"
          ? "English"
          : ln_code === "es"
            ? "Español"
            : ln_code === "pt"
              ? "Português"
              : ln_code === "ja"
                ? "日本語"
                : ln_code === "fr"
                  ? "Français"
                  : ln_code}
      </span>
    </div>
  );
};

export default function Footer() {
  const { t_url, t } = use_store();
  return (
    <footer className="pb-[140px] w-full bg-surface-secondary border-t-[1px] border-lines py-[64px]">
      <div className="max-w-[1200px] mx-auto px-[24px]">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-[64px]">
          <div>
            <img
              src={get_cdn_url("/favicon_2.webp")}
              alt="Lulu Loyal"
              className="h-[48px] mb-[16px]"
            />
            <h3 className="text-[20px] font-semibold mb-[8px]">
              {t("Lulu Loyal")}
            </h3>
            <p className="text-[14px] text-[#666666] leading-[20px]">
              {t(
                "Anonymously view any public user’s recent followers on Instagram.",
              )}
            </p>
          </div>

          <div>
            <h4 className="text-[12px] font-semibold tracking-[1px] mb-[20px] text-[#333333]">
              {t("LINKS")}
            </h4>
            <ul className="space-y-[16px]">
              <li>
                <a
                  href="#"
                  className="text-[14px] text-[#333333] hover:text-[#FF6B35]"
                >
                  {t("How Lulu Works")}
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-[14px] text-[#333333] hover:text-[#FF6B35]"
                >
                  {t("Why Use Lulu Loyal?")}
                </a>
              </li>
              <li>
                <a
                  href={t_url("/try")}
                  className="text-[14px] text-[#333333] hover:text-[#FF6B35]"
                >
                  {t("Prices")}
                </a>
              </li>
              <li>
                <a
                  href={t_url("/try")}
                  className="text-[14px] text-[#333333] hover:text-[#FF6B35]"
                >
                  {t("Resources")}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-[12px] font-semibold tracking-[1px] mb-[20px] text-[#333333]">
              {t("LEGAL")}
            </h4>
            <ul className="space-y-[16px]">
              <li>
                <a
                  href="/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[14px] text-[#333333] hover:text-[#FF6B35]"
                >
                  {t("Privacy Policy")}
                </a>
              </li>
              <li>
                <a
                  href="/terms-of-use"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[14px] text-[#333333] hover:text-[#FF6B35]"
                >
                  {t("Terms of Use")}
                </a>
              </li>
              <li>
                <a
                  href="/refund-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[14px] text-[#333333] hover:text-[#FF6B35]"
                >
                  {t("Refund Policy")}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-[12px] font-semibold tracking-[1px] mb-[20px] text-[#333333]">
              {t("CONTACT US")}
            </h4>
            <p className="text-[14px] text-[#333333]">
              {t("support@lululoyal.com")}
            </p>
          </div>
        </div>

        <div className="pt-[32px]">
          <p className="text-[13px] text-[#999999]">
            {t("© 2025 Lulu Loyal. All Rights Reserved.")}
          </p>
        </div>

        {/* Language Switcher */}
        <div className="pt-[48px] border-t-[1px] border-lines mt-[48px]">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-[12px]">
            <LangButton flag="🇬🇧" ln_code="en" />
            <LangButton flag="🇪🇸" ln_code="es" />
            <LangButton flag="🇵🇹" ln_code="pt" />
            <LangButton flag="🇯🇵" ln_code="ja" />
            <LangButton flag="🇫🇷" ln_code="fr" />
          </div>
        </div>
      </div>
    </footer>
  );
}
